import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { useAuthentication } from '@pkg/hooks';

import { YAT_PROFILE_PAGE } from '@app/routes';

import { Link, Links } from '../Footer/Footer.style';

import { Hamburger, Line, LoginButton, Menu } from './MobileMenu.style';

const topLineVariants = {
    open: { y: 9, rotate: 45 },
    closed: { y: 0, rotate: 0 },
};

const middleLineVariants = {
    hidden: { opacity: 0, scale: 0 },
    visible: { opacity: 1, scale: 1 },
};

const bottomLineVariants = {
    open: { y: -9, rotate: -45 },
    closed: { y: 0, rotate: 0 },
};

interface Props {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export function MobileMenu({ open, setOpen }: Props) {
    const { handleAuthenticate } = useAuthentication();

    return (
        <>
            <Hamburger onClick={() => setOpen(!open)}>
                <Line
                    variants={topLineVariants}
                    animate={open ? 'open' : 'closed'}
                    style={{ originX: '50%', originY: '50%' }}
                />

                <Line variants={middleLineVariants} animate={open ? 'hidden' : 'visible'} />

                <Line
                    variants={bottomLineVariants}
                    animate={open ? 'open' : 'closed'}
                    style={{ originX: '50%', originY: '50%' }}
                />
            </Hamburger>

            <AnimatePresence>
                {open && (
                    <Menu initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                        <Links>
                            <LoginButton onClick={(event) => handleAuthenticate(event, { redirect: YAT_PROFILE_PAGE })}>
                                Log In
                            </LoginButton>
                            <Link href="https://legal.y.at/privacy-policy" target="_blank" rel="noreferrer">
                                Privacy Policy
                            </Link>
                            <Link href="https://legal.y.at/terms" target="_blank" rel="noreferrer">
                                Terms of Service
                            </Link>
                            <Link href="https://legal.y.at/disclosure" target="_blank" rel="noreferrer">
                                Disclosure
                            </Link>
                            <Link href="https://emojis.y.at/support" target="_blank" rel="noreferrer">
                                Help
                            </Link>
                        </Links>
                    </Menu>
                )}
            </AnimatePresence>
        </>
    );
}
